var functions = {};
const VueScroll = {
  bind: function(el, binding) {
    (functions[el.id] = () => {
      var parent = el.parentElement;
      var position = binding.arg;
      var offset = 0;
      // this logic is not finished. This only accounts for if the child is at the limit of the parent && at the edge of the window... So, not a perfect scroll directive
      if (position === "bottom") {
        offset =
          Math.round(
            parent.getBoundingClientRect().bottom - window.innerHeight
          ) +
          Math.round(
            parent.scrollHeight - (parent.scrollTop + parent.clientHeight)
          );
      } else if (position === "left") {
        offset = parent.scrollLeft + parent.getBoundingClientRect().left;
      } else if (position === "right") {
        offset =
          Math.round(parent.getBoundingClientRect().right - window.innerWidth) +
          Math.round(
            parent.scrollWidth - (parent.scrollLeft + parent.clientWidth)
          );
      } else {
        offset = Math.round(
          parent.scrollTop + parent.getBoundingClientRect().top
        );
      }
      if (window.offset === undefined) {
        window.offset = offset;
        setTimeout(() => {
          binding.value(window.offset, el);
          window.offset = undefined;
        }, 50);
      } else {
        window.offset = offset;
      }
    }),
      document.addEventListener("scroll", functions[el.id]);
  },
  unbind(el) {
    document.removeEventListener("scroll", functions[el.id]);
  }
};

export default VueScroll;
